export default "__VITE_ASSET__CcqOFTBa__"